export const helpLoadingSelector = state => state.pageHelp.pageHelp.helpLoading;
export const pageHelpLoadingSelector = state => state.pageHelp.pageHelp.pageHelpLoading;
export const helpContentSelector = state => state.pageHelp.pageHelp.helpContent;
export const helpContentsSelector = state => state.pageHelp.pageHelp.helpContents;
export const previousSectionSelector = state => state.pageHelp.pageHelp.previousSection;
export const helpAddingSelector = state => state.pageHelp.pageHelp.helpAdding;
export const helpUpdatingSelector = state => state.pageHelp.pageHelp.helpUpdating;
export const helpContentDeletingSelector = state => state.pageHelp.pageHelp.contentDeleting;
export const contentsForExportSelector = state => state.pageHelp.pageHelp.helpContentsForExport;
export const contentsForExportLoadingSelector = state => state.pageHelp.pageHelp.helpContentsForExportLoading;
export const sendingContentsForImportSelector = state => state.pageHelp.pageHelp.sendingContentsForImport;
